import clsx from 'clsx';
import React from 'react';

export type ButtonGroupProps = {
  children?: React.ReactNode;
  /**
   * Whether the ButtonGroup should be full width or not
   *
   * @defaultValue false
   */
  fullWidth?: boolean;
  /**
   * How the children should be justified within the ButtonGroup
   *
   * @defaultValue undefined
   */
  justifyContent?: 'start' | 'end' | 'center' | 'between' | 'around' | 'evenly';
  /**
   * Renders the children in the opposite direction
   *
   * @defaultValue false
   */
  reverse?: boolean;
  /**
   * Transforms ButtonGroup to render children vertically
   *
   * @defaultValue false
   */
  vertical?: boolean;
};

const justifyClass: { [justify in NonNullable<ButtonGroupProps['justifyContent']>]: `justify-${justify}` } = {
  start: 'justify-start',
  end: 'justify-end',
  center: 'justify-center',
  between: 'justify-between',
  around: 'justify-around',
  evenly: 'justify-evenly',
};

export const ButtonGroup = ({
  children,
  fullWidth,
  justifyContent,
  reverse = false,
  vertical = false,
}: ButtonGroupProps): JSX.Element => (
  <div
    className={clsx('flex', justifyContent ? justifyClass[justifyContent] : undefined, {
      'w-full': fullWidth,
      'flex-col space-y-8': vertical,
      'space-x-8': !vertical,
      'flex-col-reverse': vertical && reverse,
      'flex-row-reverse': !vertical && reverse,
    })}
  >
    {children}
  </div>
);
